import { Box } from 'braid-design-system';

export const ScreenReaderSkipTarget = ({ name }: { name: string }) => (
  <Box outline="none" tabIndex={-1} id={name} />
);
